import React, { useState } from 'react';
import { fetchMapImage } from '../../api/api';
import { getMainBuildingCoordinates } from '../report/blocksPdf/renderMapImage';
import { useReportTemplateContext } from '../report/ReportTemplate/ReportTemplateContext';

const fallbackCoordinates = [{ lat: 60.192059, lng: 24.945831 }]; // Helsinki as default

const MapDebug = () => {
  const [imageUrl, setImageUrl] = useState(null);
  const [error, setError] = useState(null);

  let mainBuildingCoordinates = fallbackCoordinates;

  try {
    const context = useReportTemplateContext(); // will fail if provider not present
    const { rakennusData, mergedRakennusData } = context || {};
    mainBuildingCoordinates = getMainBuildingCoordinates(rakennusData, mergedRakennusData) || fallbackCoordinates;
  } catch {
    // Context unavailable, use fallback
    mainBuildingCoordinates = fallbackCoordinates;
  }

  const fetchMap = async () => {
    setError(null);
    setImageUrl(null);

    try {
      const base64 = await fetchMapImage({
        lat: mainBuildingCoordinates[0].lat,
        lng: mainBuildingCoordinates[0].lng,
        zoom: 17,
        width: 942,
        height: 624,
        markers: mainBuildingCoordinates,
        _cb: Date.now(), // prevent caching
      });
      setImageUrl(base64);
    } catch (err) {
      console.error(err);
      setError(err.message || 'Failed to fetch image');
    }
  };

  return (
    <div className="p-4">
      {/*<h2>Map Debugger</h2>
       Button section (currently disabled)
    <div className="mb-3">
      <button
        className="btn btn-primary me-2"
        onClick={fetchMap}
        style={{ backgroundColor: '#04aa00', borderColor: '#04aa00' }}
      >
        Fetch Map
      </button>
    </div>
    */}
      {error && <p style={{ color: 'red' }}>Error: {error}</p>}

      {imageUrl && (
        <img
          src={imageUrl}
          alt="Map Debug"
          style={{ marginTop: 20, border: '1px solid black', maxWidth: '100%' }}
        />
      )}
    </div>
  );
};

export default MapDebug;